import React from "react";
import { useNavigate } from "react-router-dom";
import "../../assets/css/paiements/PaiementStatusModal.css";

const PaiementStatusModal = ({ status, onClose }) => {
  const navigate = useNavigate();
  const isSuccess = status === "success";

  return (
    <div className="orange_modal_overlay">
      <div className="paiement_status_modal_content">
        <div className={`status_icon ${isSuccess ? "success" : "failed"}`}>
          {isSuccess ? "✓" : "✕"}
        </div>

        <h3 className="status_title">
          {isSuccess ? "Paiement confirmé !" : "Le paiement a échoué"}
        </h3>

        <p className="status_description">
          {isSuccess
            ? "Votre action a bien été prise en compte."
            : "Le paiement a échoué ou a été annulé. Vous pouvez réessayer depuis votre annonce."}
        </p>

        <button
          className="article_success_btn_primary"
          onClick={() => {
            onClose?.();
            navigate("/utilisateur/mesAnnonces");
          }}
        >
          Voir mes annonces
        </button>
      </div>
    </div>
  );
};

export default PaiementStatusModal;
